export default __webpack_public_path__ + "static/media/AppImage.98c0799a.webp";